import { styled } from '@mui/material/styles';
import Button, { ButtonProps } from '@mui/material/Button';

export default function OutlinedButton({ ...props }: ButtonProps) {
  const StyledComponent = styled(Button)<ButtonProps>(({ theme }) => ({
    color: theme.palette.text.primary,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '100%',
    borderRadius: '1px',
    textTransform: 'none',
    background: 'transparent',
    border: `1px solid ${theme.palette.text.primary}`,
    boxShadow: 'none',

    '&:disabled': {
      color: '#D0D3D6',
      border: '1px solid #D0D3D6',
      'svg > path': {
        fill: '#d0d3d6',
      },
    },

    '&:hover': {
      boxShadow: 'none',
    },
  }));

  return <StyledComponent {...props} />;
}
